import http from 'common-module/src/util/http';

/** 
 * 自定义字段控件类型列表
 * @returns {Promise<Array>}
*/
export const queryFieldControl = async (data = {}) => {
  return http.post('/form-control/list', data);
};

/** 
 * 检验自定义字段是否可以删除
 * @param customFieldId 字段id
 * @param fieldName 字段名称（非必填）
 * @param projectId 项目id
 * @returns {Promise<*>}
*/
export const checkDeleteField = async (data = {}) => {
  return http.post('/profile/custom-field/check/delete-field', data);
};

/** 
 * 删除字段
 * @param id 被删除字段的id
 * @returns {Promise<*>}
*/
export const deleteField = async (data = {}) => {
  return http.post('/profile/custom-field/delete', data);
};